import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

export interface RekapRow {
  id: number;
  tgl: number;
  tanggal: string;
  awal: number;
  masuk: number;
  pindahan: number;
  jumlah: number;
  dipindah: number;
  keluar_hidup: number;
  mati_total: number;
  mati_ge48: number;
  mati_lt48: number;
  jumlah_out: number;
  lama_dirawat: number;
  sama_hari: number;
  sisa: number;
  sisa_kelas: {
    vip_non: number;
    k1: number;
    k2: number;
    k3: number;
    iso: number;
  };
  koreksi: Record<string, RekapKoreksi> | null;
  edited_at: string | null;
  sumber_hitung: string | null;
  kosong?: boolean;
}

export interface RekapKoreksi {
  nilai: number;
  asal: number;
  alasan: string | null;
  oleh: number | null;
  nama: string | null;
  pada: string;
  sumber: string;
}

export interface RekapTotal {
  masuk: number;
  pindahan: number;
  dipindah: number;
  keluar_hidup: number;
  mati_total: number;
  mati_ge48: number;
  mati_lt48: number;
  jumlah_out: number;
  jumlah: number;
  lama_dirawat: number;
  sama_hari: number;
  hari_perawatan: number;
  sisa: number;
  sisa_kelas: {
    vip_non: number;
    k1: number;
    k2: number;
    k3: number;
    iso: number;
  };
}

export interface RekapWard {
  unit_kode: string;
  rows: RekapRow[];
  total: RekapTotal;
  tt_tersedia: number;
  sumber_hitung: string | null;
  computed_at: string | null;
}

async function updateKoreksi(
  id: number,
  fields: Record<string, number>,
  alasan: string | null = null
): Promise<RekapWard> {
  const response = await http
    .putData(`/laporan/rp1-ranap/rekap-harian/${id}`, { fields, alasan })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data.ward;
}

async function resetKoreksi(
  id: number,
  fields: string[] = []
): Promise<RekapWard> {
  const response = await http
    .deleteDataParam(`/laporan/rp1-ranap/rekap-harian/${id}/koreksi`, {
      data: { fields }
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data.ward;
}

export default {
  updateKoreksi,
  resetKoreksi
};

